<template>
	<div class="knd-image-container" ref="container" v-if="url">
		<figure class="knd-figure" :class="['size-' + size]">
			<img
				class=""
				:alt="description"
				:data-srcset="
					baseUrl + mobile_url  + ' 300w, ' + 
					baseUrl + url + ' 600w'
				"
				:src="baseUrl + url"
				sizes="(max-width: 600px) 300px,600px"
			/>
			<figcaption class="imagepart__caption" v-html="description" />
		</figure>
	</div>
</template>

<script>
import { ref } from 'vue';

export default {
    components: {
    },
    props: {
      url: String,
      mobile_url: String,
      description: String,
      media: Array,
      size: String
    },

    setup(props) {
      let baseUrl = ref(process.env.VUE_APP_ASSETS)

      return {
        baseUrl
      };
    },
  };

</script>

<style lang="scss">

.knd-figure {
  margin: 0 auto;
	// background: $off-white;

	&.size-sm {
		max-width: 150px;
	}
	
  img {
		width: 100%;
		display: block;
		
		transition: height .2s ease-in, opacity .5s ease-in;
		
		&.lazy {
			opacity: 0;
			height: 200px;
			width: 100%;
		}
  }
  .imagepart__caption {
    text-align: right;
  }
}

</style>